import { Loader } from '@recruit-robin/robin-theme/web-components';
import { css } from '@recruit-robin/robin-theme/web-styles';

import { af } from '../theme';

/**
 * The ring draws itself in `--foreground-color`. `customCss` lands after the theme's own variant
 * styles, so this wins over the fuchsia it would otherwise set.
 */
const inkCss = css`
  --foreground-color: ${af.ink};
`;

export type ApplySpinnerProps = {
  size: number;
};

/**
 * The theme's ring spinner, in the flow's ink rather than Robin's fuchsia.
 *
 * For a wait inside something already on screen — a button that was just pressed, a calendar that
 * has not arrived. A wait that replaces the page is `ApplyLoader`'s scooter instead.
 */
export const ApplySpinner = ({ size }: ApplySpinnerProps) => <Loader size={size} variant="ring-4" customCss={inkCss} />;
